import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const OrderpickingMoveAssetRoute: Route = {
  path: 'orderpicking/move-asset',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/orderpicking.component').then((m) => m.OrderpickingMoveAssetComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
